import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import ChallengeBanner from 'components/containers/challenge/ChallengeBanner';
import ChallengeInfo from  'components/containers/challenge/ChallengeInfo';
import ChallengeTodoList from 'components/containers/challenge/ChallengeTodoList';
import ChallengeDescription from 'components/containers/challenge/ChallengeDescription';
import ChallengeSampleProof from 'components/containers/challenge/ChallengeSampleProof';
import CenterModal from 'components/presenters/modal/CenterModal';
import GroupProjectMainFooter from  'components/containers/group/GroupProjectMainFooter';
import BottomConfirmModal from 'components/presenters/modal/BottomConfirmModal';
import constants from 'utils/constants'
import server from 'server/serverController2';
import { useHistory } from 'react-router-dom';
import { formatDate, getDatesByDay } from 'utils/utils.js';

import LoadingModal from 'components/presenters/modal/LoadingModal';

  
// 모달 창 띄우기
export default function GroupProjectMainLayout({ targetNo, type }) {
  const history = useHistory();
  const sampleMemberCount = 2;
  const [sampleMember, setSampleMember] = useState([]);
  const [requesting, setRequesting] = useState(false);
  const [memberNum, setMemberNum] = useState(null);
  const [maxMemberNum, setMaxMemberNum] = useState(null);
  const [todayTaskExist, setTodayTaskExist] = useState(null);

  const [initCenterModal, setInitCenterModal] = useState(false);
  const [centerModalVisible, setCenterModalVisible] = useState(false);
  const [centerModalDataList, setCenterModalDataList] = useState({});
  const [onModalComplete, setOnModalComplete] = useState(null);
  const [onModalCancel, setOnModalCancel] = useState(null);


  //bottom confirm modal
  const [showBottomConfirmModal, setShowBottomConfirmModal] = useState(false);

  //Init Center Modal State
  useEffect(()=>{
    if(initCenterModal === true)
    {
      setCenterModalVisible(false);
      setCenterModalDataList({})
      setOnModalComplete(null);
      setOnModalCancel(null);
      setInitCenterModal(false);
    }
  }, [initCenterModal])



  //캠페인 정보 불러오기
  const [challengeInfo, setChallengeInfo] = useState({});
  const infoCallBack = (jsonData) => {
    try
    {
      if (jsonData.success !== 1) {
        setCenterModalVisible(true);
        setCenterModalDataList({description:`예기치 못한 오류가 발생하였습니다.`});
        setOnModalComplete(()=>()=>{
          history.push('/');
          setInitCenterModal(true);
        })
        return;
      }

      let receivedData = jsonData.data;
      if(![null, undefined].includes(receivedData['max_capacity']))
      {
        setMaxMemberNum(receivedData['max_capacity'])
      } 
      
      let taskDateList = getDatesByDay(receivedData['start_date'],receivedData['end_date'],receivedData['day']);
      if(receivedData['is_member'] === true)
      {
        if(taskDateList.includes(formatDate()))
        {
          setTodayTaskExist(true)
        }
        else
        {
          setTodayTaskExist(false)
        }

      }

      setChallengeInfo(jsonData.data);
    }
    catch(err)
    {
      console.log(err)
    }
    
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    let apiEndPoint = `groups/projects/${targetNo}`;
    server.getRequestData(apiEndPoint , infoCallBack );
 
    apiEndPoint =  `groups/projects/${targetNo}/members?limit=${sampleMemberCount}`;
    server.getRequestData(apiEndPoint,(res)=>{
      if(res?.data?.members)
      {
        const memberList = res.data.members;
        setSampleMember(memberList)
      }
    });

    apiEndPoint =  `groups/projects/${targetNo}/members?get_total=true`;
    server.getRequestData(apiEndPoint,(res)=>{
      if(res?.data?.count)
      {
        setMemberNum(parseInt(res['data']['count']));
      }
    });
  }, []);

  const showConfirmationJoinModal = () => {
    setCenterModalDataList({title: '챌린지 참여하기', description: challengeInfo['join_description']})
    setCenterModalVisible(true);
    setOnModalComplete(() => () => requestJoin());
    setOnModalCancel(() => () => setInitCenterModal(true));
  }
  // 가입하기
  const requestJoin = () => { 
    if (requesting) return;
    setRequesting(true);
    setInitCenterModal(true);

    let data = {};

    let apiEndPoint =`groups/projects/${targetNo}/members`;
    server.postRequestData(apiEndPoint , JSON.stringify(data), joinCallBack );  
  };

  const joinCallBack = (res) => {
    setRequesting(false);
    if (res.success === 1) {
      window.location.reload();
    } else {
      let errData = res['error']['res_data'];
   
      setCenterModalVisible(true);
      setOnModalComplete(()=>()=>{
        setInitCenterModal(true);
      })
      if (errData['detail_code'] === 'LOGIN_REQ') {
        setCenterModalDataList({description:`로그인이 필요합니다.`});
        setOnModalComplete(()=>()=>{
          history.replace(`/social?redirect_path=/campaign/${targetNo}`);
          setInitCenterModal(true);
        })
      } else if (errData['detail_code'] === 'CAMPAIGN_ALREADY_STARTED') {
        setCenterModalDataList({description:`이미 캠패인이 시작되었어요.`});
      } else if (errData['detail_code'] === 'BLOCKED_USER') {
        setCenterModalDataList({description:`해당 유저는 참여가 불가능 해요.`});
      } else if (errData['detail_code'] === 'CAMPAIGN_DOES_NOT_EXIST') {
        setCenterModalDataList({description:`해당 캠페인을 찾을 수 없어요.`});
      } else if (errData['detail_code'] === 'ALREADY_JOINED_CAMPAIGN') {
        setCenterModalDataList({description:`해당 캠페인은 이미 참여중 이에요.`});
      } else if (errData['detail_code'] === 'EXCEEDED_MAX_CAPACITY') {
        setCenterModalDataList({description:`참여 정원을 초과하였어요.`});
      } else {
        setCenterModalDataList({description:`예기치 못한 오류가 발생하였습니다.`});
        setOnModalComplete(()=>()=>{
          history.push('/');
          setInitCenterModal(true);
        })
      }
      
    }  
  };


  let bannerImg = null;
  if(challengeInfo?.cover_img)
  {
    bannerImg = (type==='campaign') ? `${constants['imagePath']}/campaign_cover_img/${challengeInfo['cover_img']}`:`${constants['imagePath']}/group_project_cover_img/${challengeInfo['cover_img']}`;
  }
  
  return (
    <CampaignInner>
      <ChallengeBanner imgSrc={bannerImg} />
      <div style={{
                    paddingTop : 'calc(100vw * (15 / 375))', 
                    
                    marginBottom:'calc(100vw * (32 / 375))', 
                  }}>
        <ChallengeInfo 
          challengeInfo={challengeInfo} 
          type={type} 
          totalNum={memberNum} 
          maxMemberNum={maxMemberNum}
          sampleMember={sampleMember}
        />
      </div>
      <SectionDivider></SectionDivider>
      <div style={{ 
        marginTop:'calc(100vw * (25 / 375))', 
        marginBottom:'calc(100vw * (25 / 375))' }}>
        <ChallengeTodoList challengeInfo={challengeInfo} todayTaskExist={todayTaskExist} />
      </div>
      <SectionDivider></SectionDivider>
      <div style={{ 
        marginTop:'calc(100vw * (25 / 375))',
        marginBottom:'calc(100vw * (30 / 375))' 
      }}>
        <ChallengeSampleProof proofList={challengeInfo['sample_proof']} type={type} />
      </div>
      
      <SectionDivider></SectionDivider>
      <div style={{ 
        marginTop:'calc(100vw * (25 / 375))',
        marginBottom:'calc(100vw * (30 / 375))' }}>
        <ChallengeDescription description={challengeInfo['description']} />
      </div>
      <GroupProjectMainFooter
        challengeInfo={challengeInfo}
        requestJoin={requestJoin}
        setInitCenterModal={setInitCenterModal}
        setCenterModalVisible={setCenterModalVisible}
        setCenterModalDataList={setCenterModalDataList}
        setOnModalComplete={setOnModalComplete}
        setOnModalCancel={setOnModalCancel}
        showConfirmationJoinModal={showConfirmationJoinModal}
      />
      {
        (requesting)?(<LoadingModal />):(null)
      }
      <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
    </CampaignInner>
  );
}

const CampaignInner = styled.div`
  height: 100%;
  overflow-y: scroll;
`;
const SectionDivider = styled.div`
  background: #EFEFEF;
  height : 1px;
  margin: 0 calc(100vw * (20 / 375));
`
